import { ChangeEvent, MutableRefObject, RefObject, useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../context/AppContextProvider";
import i18next from "i18next";
import i18n from "../i18n";
import { Language, languages } from "../languages/languages";
import { Trans, useTranslation } from "react-i18next";

export default function LangSwitcher() {
    const { resolvedLanguage } = i18n;
    const { t } = useTranslation();

    const currentLanguage = languages.find(e => e.value === resolvedLanguage) || languages[0];

    const visibleLanguages = languages.filter(language => language.value != currentLanguage.value);
    const [areOptionsOpen, setAreOptionsOpen] = useState(false);

    const select = useRef<HTMLDivElement>(null);

    function useOutsideAlerter(ref: RefObject<HTMLDivElement | null>) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event: MouseEvent) {
                if (ref.current && !ref.current.contains(event.target as Node)) {
                    setAreOptionsOpen(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(select);

    return (
        <div ref={select} className="custom-select" role="select">
            <button
                className="custom-select-opener transition-all duration-200"
                type="button"
                onClick={() => setAreOptionsOpen((i) => !i)}
            >
                <div
                    style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        lineHeight: "24px",
                        display: "flex",
                        alignItems: "center",
                        color: "#30374A",
                        gap: "10px",
                    }}
                >
                    {currentLanguage?.icon}
                    <label className="cursor-pointer">{t(`languageLabel.${currentLanguage?.value}`)}</label>
                </div>
                <svg
                    style={{
                        rotate: areOptionsOpen ? "180deg" : "0deg",
                        transition: "all .1s ease-in-out",
                    }}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5 7.96378L10 12.9638L15 7.96378"
                        stroke="#5E7499"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            {/* OPTIONS CONTAINER */}
            <div
                className={`custom-select-options-container z-10 ${areOptionsOpen ? "opened" : ""}`}
            >
                <div>
                    {visibleLanguages.map((lang) => {
                        return (
                            <button
                                key={lang.value}
                                className="custom-select-option"
                                type="button"
                                onClick={() => {
                                    i18next.changeLanguage(lang.value)
                                    setAreOptionsOpen(false);
                                }}
                            >
                                {lang.icon}
                                {t(`languageLabel.${lang.value}`)}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div >
    );
}